export default __webpack_public_path__ + "static/media/folder-open-regular.2ebed1e9.svg";